import { getDomainName } from "./domain";

/* eslint-disable */
export default {
  /**
   * @desc name  cookiekey
   */
  getCookie(name: string) {
    var cookieValue = null;
    if (document.cookie && document.cookie != "") {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        // var cookie = jQuery.trim(cookies[i]);
        var cookie = cookies[i].replace(/^\s*|\s*$/g, "");
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) == name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  },
  /**
   * @desc name  cookiekey
   */
  setCookie(name: string, value: string, Days = 356, currentDomain = true) {
    const date = new Date().setDate(new Date().getDate() + Days);
    document.cookie = `${name}=${value};expires=${date};${
      currentDomain ? `domain=.${getDomainName(2)}.com;` : ""
    }path=/`;
  },
  /**
   * @desc name  cookiekey
   */
  delCookie(name: string) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    // var cval = this.getCookie(name);
    // if (cval != null) {
    //   document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    // }
  },
};
